import React from 'react';
import './Game2.css';

export default function Game2() {
  return (
    <div className='Game2-Body'>
      <h1>sudoku game</h1>
      <div className='Game2-Box'>
      sudoku game
      </div>
    </div>
  )
}
